import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, empty, Subject } from 'rxjs';
import { catchError, tap, switchMap } from 'rxjs/operators';
import { AuthService } from 'app/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService, private _router: Router) { }

    refreshingAccessToken: boolean;

    accessTokenRefreshed: Subject<any> = new Subject();


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {

        request = this.addAuthHeader(request);

        return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401 && ! this.refreshingAccessToken) {
                return this.refreshAccessToken()
                    .pipe(
                        switchMap(() => {
                            request = this.addAuthHeader(request);
                            return next.handle(request);
                        }),
                        catchError((err: any) => {
                            this.authService.clearStorage();
                            this._router.navigate(['/login'])
                            return empty();
                        })
                    )
            }else if((error.status == 403) || (error.status == 406)){
                this.authService.clearStorage()
                this._router.navigate(['/login'])
            }

            return throwError(error);
        })
        )
    }

    refreshAccessToken() {
        if (this.refreshingAccessToken) {
            return new Observable(observer => {
                this.accessTokenRefreshed.subscribe(() => {
                    observer.next();
                    observer.complete();
                })
            })
        } else {
            this.refreshingAccessToken = true;
            return this.authService.refreshTokens().pipe(
                tap(() => {
                this.refreshingAccessToken = false;
                this.accessTokenRefreshed.next();
                })
            )
        }
        
    }


    addAuthHeader(request: HttpRequest<any>) {
        const token = this.authService.accessToken;
        
        return request.clone({
            setHeaders: {
            'Authorization': 'Bearer ' + token,
            }
        })
    }

}